<template>
  <div v-if="!isEmpty">
    <div v-for="(val, i) in value" v-bind:key="i" class="invalid-feedback d-block">{{val}}</div>
  </div>
</template>

<script>
export default {
  name: "local-errors",
  computed: {
    isEmpty: function () {
      return !this.value || this.value.length === 0;
    }
  },
  props: ["id", "value"]
}
</script>
